import React from "react";
import Sidebar from "@/components/Sidebar";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { GraduationCap, SignOut, List } from "@phosphor-icons/react";

export default function AppLayout({ children, title, eyebrow, actions }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-white flex">
      <Sidebar />
      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-50 bg-black/40" onClick={() => setMobileOpen(false)}>
          <div
            className="absolute left-0 top-0 bottom-0 w-72 bg-[#F4F4F0] border-r border-[#EAEAE6]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="px-6 py-6 border-b border-[#EAEAE6] flex items-center gap-3">
              <div className="w-9 h-9 bg-[#E25822] flex items-center justify-center">
                <GraduationCap size={22} weight="bold" color="#FFFFFF" />
              </div>
              <div className="font-heading text-lg font-black">UzviS Learning</div>
            </div>
            <nav className="py-4">
              <Link to="/dashboard" className="block px-6 py-3 text-sm" onClick={() => setMobileOpen(false)}>
                My Learning
              </Link>
              <Link to="/catalog" className="block px-6 py-3 text-sm" onClick={() => setMobileOpen(false)}>
                Catalog
              </Link>
              {user?.role === "admin" && (
                <>
                  <div className="px-6 pt-4 pb-1 eyebrow">Admin</div>
                  <Link to="/admin" className="block px-6 py-3 text-sm" onClick={() => setMobileOpen(false)}>
                    Overview
                  </Link>
                  <Link to="/admin/courses" className="block px-6 py-3 text-sm" onClick={() => setMobileOpen(false)}>
                    Manage Courses
                  </Link>
                  <Link to="/admin/users" className="block px-6 py-3 text-sm" onClick={() => setMobileOpen(false)}>
                    Manage Users
                  </Link>
                </>
              )}
              <button
                onClick={handleLogout}
                className="w-full text-left px-6 py-3 text-sm text-[#5C5C58] border-t border-[#EAEAE6] mt-4 flex items-center gap-2"
              >
                <SignOut size={16} /> Sign out
              </button>
            </nav>
          </div>
        </div>
      )}

      <main className="flex-1 min-w-0">
        {/* Top header */}
        <header className="sticky top-0 z-40 bg-white border-b border-[#EAEAE6]">
          <div className="px-6 lg:px-10 h-16 flex items-center gap-4">
            <button
              className="lg:hidden p-2 -ml-2"
              onClick={() => setMobileOpen(true)}
              data-testid="mobile-menu-toggle"
            >
              <List size={22} />
            </button>
            <div className="flex-1">
              {eyebrow && <div className="eyebrow">{eyebrow}</div>}
              {title && (
                <h1 className="font-heading text-xl sm:text-2xl font-bold tracking-tight" data-testid="page-title">
                  {title}
                </h1>
              )}
            </div>
            <div className="flex items-center gap-3">{actions}</div>
          </div>
        </header>

        <div className="page-fade px-6 lg:px-10 py-8 max-w-[1400px]">{children}</div>
      </main>
    </div>
  );
}
